module.exports = __webpack_public_path__ + "static/mastery-6cd9683f14bd45a45fd54aaecfb49f4b.jpg";